
$(function () {
    $('.btn-more').on('mouseenter', function () {
        $(this).parents('li').addClass('item-hover');
    }).on('mouseleave', function () {
        $(this).parents('li').removeClass('item-hover');
    });

    $(function () {
        setTimeout(function () {
            $('.show-message').fadeOut(300, function () { $(this).hide(); });
        }, 5000);
    })

    if(window.localStorage.getItem('cookie_notice') !== 'agree'){
        $('#cookie_notice_banner_div').fadeIn(); 
    }


    $('.owl-carousel').owlCarousel({
        items:1,
        loop:true,
        dots:true,
        responsive:{
            0:{
                center: false,
                stagePadding: 0,
                margin:5,
            },
            768:{
                center: true,
                stagePadding: 100,
                margin:25,
                items:1
            },
            1200:{
                center: true,
                stagePadding: 154,
                margin:0,
                items:1
            }
        }
    });

    $('.nav-link').on('click', function () {
        if ($(this).data('target') === '#about') {
            $('.btn-book').show();
        } else {
            $('.btn-book').hide();
        }
    });
});
